import { useLanguage } from '../contexts/LanguageContext';

// Translation data
const translations = {
  en: {
    // Navigation
    'nav.shop': 'Shop',
    'nav.sell': 'Sell', 
    'nav.myItems': 'My Items',
    'nav.favorites': 'Favorites',
    'nav.messages': 'Messages',
    
    // Common
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.view': 'View',
    'common.close': 'Close',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.clear': 'Clear',
    'common.submit': 'Submit',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.previous': 'Previous',
    
    // Auth
    'auth.signIn': 'Sign In',
    'auth.signUp': 'Sign Up',
    'auth.signOut': 'Sign Out',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.name': 'Name',
    'auth.confirmPassword': 'Confirm Password',
    'auth.forgotPassword': 'Forgot Password?',
    'auth.rememberMe': 'Remember Me',
    'auth.signInWithGoogle': 'Sign in with Google',
    
    // Listing
    'listing.title': 'Title',
    'listing.titlePlaceholder': 'e.g., Bundle of newborn onesies',
    'listing.price': 'Price',
    'listing.category': 'Category',
    'listing.condition': 'Condition',
    'listing.description': 'Description',
    'listing.location': 'Location',
    'listing.photos': 'Photos',
    'listing.createListing': 'Create New Listing',
    'listing.creating': 'Creating Listing...',
    'listing.publish': 'Publish Listing',
    'listing.editListing': 'Edit Listing',
    'listing.deleteListing': 'Delete Listing',
    'listing.markAsSold': 'Mark as Sold',
    'listing.itemSold': 'Item Sold',
    'listing.messageSeller': 'Message Seller',
    'listing.recordPayment': 'Record Payment',
    'listing.updatePayment': 'Update Payment',
    
    // Categories
    'category.all': 'All',
    'category.prenatal': 'Pre-natal',
    'category.clothing': 'Clothing',
    'category.gear': 'Gear',
    'category.toys': 'Toys',
    'category.feeding': 'Feeding',
    'category.nursery': 'Nursery',
    'category.other': 'Other',
    
    // Conditions
    'condition.excellent': 'Excellent',
    'condition.good': 'Good',
    'condition.fair': 'Fair',
    'condition.poor': 'Poor',
    
    // Payment
    'payment.amount': 'Amount Paid',
    'payment.method': 'Payment Method',
    'payment.notes': 'Notes (Optional)',
    'payment.cash': 'Cash',
    'payment.interac': 'Interac e-Transfer',
    'payment.paypal': 'PayPal',
    'payment.venmo': 'Venmo',
    'payment.zelle': 'Zelle',
    'payment.cashApp': 'Cash App',
    'payment.other': 'Other',
    'payment.approvals': 'Payment Approvals',
    'payment.pendingApprovals': 'No Pending Approvals',
    'payment.noPendingApprovalsDescription': 'All payment requests have been reviewed.',
    'payment.pendingApprovals': 'Pending Payment Approvals',
    'payment.pending': 'pending',
    'payment.from': 'Payment from',
    'payment.requestedAt': 'Requested',
    'payment.approve': 'Approve',
    'payment.reject': 'Reject',
    'payment.rejectionReason': 'Please provide a reason for rejection:',
    
    // Messages
    'messages.noMessages': 'No messages yet',
    'messages.startConversation': 'Start a conversation',
    'messages.typeMessage': 'Type a message...',
    'messages.send': 'Send',
    'messages.unread': 'unread',
    
    // Reviews
    'reviews.noReviews': 'No reviews yet',
    'reviews.writeReview': 'Write a Review',
    'reviews.rating': 'Rating',
    'reviews.comment': 'Comment',
    'reviews.submitReview': 'Submit Review',
    
    // Pages
    'page.browse': 'Browse Items',
    'page.browseDescription': 'Find gently used baby gear from parents in your community',
    'page.myListings': 'My Listings',
    'page.myListingsDescription': 'Manage your baby items for sale',
    'page.favorites': 'My Favorites',
    'page.favoritesDescription': 'Items you\'ve saved for later',
    'page.messages': 'Messages',
    'page.profile': 'Profile',
    'page.createListing': 'Create New Listing',
    'page.createListingDescription': 'Share gently used baby items with your community',
    
    // Tagline
    'tagline': 'BabyXchange - Built by Parents, for Parents',
    
    // Additional UI Elements
    'ui.createNewListing': 'Create New Listing',
    'ui.noListingsYet': 'No listings yet',
    'ui.startSelling': 'Start selling your baby items!',
    'ui.noItemsFound': 'No items found',
    'ui.tryAdjustingFilters': 'Try adjusting your filters',
    'ui.clearFilters': 'Clear Filters',
    'ui.showing': 'Showing',
    'ui.results': 'results',
    'ui.sortBy': 'Sort By',
    'ui.newest': 'Newest',
    'ui.oldest': 'Oldest',
    'ui.priceLowToHigh': 'Price: Low to High',
    'ui.priceHighToLow': 'Price: High to Low',
    'ui.distance': 'Distance',
    'ui.advancedFilters': 'Advanced Filters',
    'ui.resetFilters': 'Reset Filters',
    'ui.applyFilters': 'Apply Filters',
    'ui.maxDistance': 'Max Distance',
    'ui.km': 'km',
    'ui.minPrice': 'Min Price',
    'ui.maxPrice': 'Max Price',
    'ui.ageRange': 'Age Range',
    'ui.customRange': 'Custom Range',
    'ui.from': 'From',
    'ui.to': 'To',
    'ui.months': 'months',
    'ui.useMyLocation': 'Use my current location',
    'ui.addPhotos': 'Add Photos',
    'ui.dragDropPhotos': 'Drag & drop photos here, or click to select',
    'ui.uploadPhotos': 'Upload up to 5 photos',
    'ui.addMorePhotos': 'Add More Photos',
    'ui.removePhoto': 'Remove Photo',
    'ui.description': 'Description',
    'ui.descriptionPlaceholder': 'Describe your item in detail...',
    'ui.tags': 'Tags',
    'ui.addTags': 'Add tags (e.g., Moving out, Give away)',
    'ui.pressEnter': 'Press Enter to add',
    'ui.quickMessages': 'Quick Messages',
    'ui.sendMessage': 'Send Message',
    'ui.areYouSureDelete': 'Are you sure you want to delete this listing?',
    'ui.active': 'Active',
    'ui.sold': 'Sold',
    'ui.inactive': 'Inactive',
    'ui.pending': 'Pending',
    'ui.approved': 'Approved',
    'ui.rejected': 'Rejected',
    'ui.completed': 'Completed',
    'ui.itemSold': 'Item Sold',
    'ui.signInToMessage': 'Sign in to message',
    'ui.onlyBuyersCanReview': 'Only buyers can leave reviews. Purchase this item to review the seller.',
    'ui.alreadyReviewed': 'You\'ve already reviewed this seller!',
    'ui.cannotReviewOwn': 'You cannot review your own listing.',
    'ui.signInToReview': 'Please sign in to leave a review.',
    'ui.leaveReview': 'Leave a Review',
    'ui.submitReview': 'Submit Review',
    'ui.youMayAlsoLike': 'You May Also Like',
    'ui.similarItems': 'Similar Items',
    'ui.otherListings': 'Other Listings',
    'ui.fromThisSeller': 'from this seller',
    'ui.qualityAssurance': 'Quality Assurance',
    'ui.startQA': 'Start QA',
    'ui.hideQA': 'Hide QA',
    'ui.affiliateProducts': 'Affiliate Products',
    'ui.similarProducts': 'Similar Products',
    'ui.recommendedForYou': 'Recommended for You',
    'ui.viewOnAmazon': 'View on Amazon',
    'ui.aiAssistant': 'AI Assistant',
    'ui.clearChat': 'Clear Chat',
    'ui.typeYourQuestion': 'Type your question...',
    'ui.send': 'Send',
    'ui.thinking': 'Thinking...',
    'ui.enterMessage': 'Enter your message...',
    'ui.chatWithAI': 'Chat with AI',
    'ui.aiThinking': 'AI is thinking...',
    'ui.noConversations': 'No conversations yet',
    'ui.startConversation': 'Start a conversation',
    'ui.noMessages': 'No messages yet',
    'ui.typeMessage': 'Type a message...',
    'ui.unread': 'unread',
    'ui.markAsRead': 'Mark as Read',
    'ui.searchPlaceholder': 'Search for items...',
    'ui.recentSearches': 'Recent Searches',
    'ui.clearRecent': 'Clear Recent',
    'ui.noRecentSearches': 'No recent searches',
    'ui.searchResults': 'Search Results',
    'ui.noSearchResults': 'No results found',
    'ui.tryDifferentKeywords': 'Try different keywords',
    'ui.suggestions': 'Suggestions',
    'ui.popularSearches': 'Popular Searches',
    'ui.viewAll': 'View All',
    'ui.seeMore': 'See More',
    'ui.seeLess': 'See Less',
    'ui.loadMore': 'Load More',
    'ui.noMoreItems': 'No more items',
    'ui.emptyState': 'Nothing here yet',
    'ui.comingSoon': 'Coming Soon',
    'ui.underConstruction': 'Under Construction',
    'ui.notAvailable': 'Not Available',
    'ui.soldOut': 'Sold Out',
    'ui.outOfStock': 'Out of Stock',
    'ui.inStock': 'In Stock',
    'ui.available': 'Available',
    'ui.unavailable': 'Unavailable',
    'ui.contactSeller': 'Contact Seller',
    'ui.askQuestion': 'Ask a Question',
    'ui.reportListing': 'Report Listing',
    'ui.shareListing': 'Share Listing',
    'ui.saveForLater': 'Save for Later',
    'ui.removeFromFavorites': 'Remove from Favorites',
    'ui.addToFavorites': 'Add to Favorites',
    'ui.favorited': 'Favorited',
    'ui.unfavorited': 'Unfavorited',
    'ui.viewProfile': 'View Profile',
    'ui.sellerInfo': 'Seller Information',
    'ui.buyerInfo': 'Buyer Information',
    'ui.location': 'Location',
    'ui.distanceAway': 'away',
    'ui.posted': 'Posted',
    'ui.updated': 'Updated',
    'ui.lastActive': 'Last Active',
    'ui.joined': 'Joined',
    'ui.memberSince': 'Member Since',
    'ui.verified': 'Verified',
    'ui.unverified': 'Unverified',
    'ui.trusted': 'Trusted',
    'ui.new': 'New',
    'ui.featured': 'Featured',
    'ui.promoted': 'Promoted',
    'ui.hot': 'Hot',
    'ui.trending': 'Trending',
    'ui.bestSeller': 'Best Seller',
    'ui.topRated': 'Top Rated',
    'ui.recommended': 'Recommended',
    'ui.similarItems': 'Similar Items',
    'ui.recentlyViewed': 'Recently Viewed',
    'ui.trendingNow': 'Trending Now',
    'ui.popularCategories': 'Popular Categories',
    'ui.allCategories': 'All Categories',
    'ui.filterBy': 'Filter By',
    'ui.all': 'All',
    'ui.any': 'Any',
    'ui.none': 'None',
    'ui.select': 'Select',
    'ui.selectAll': 'Select All',
    'ui.deselectAll': 'Deselect All',
    'ui.choose': 'Choose',
    'ui.pick': 'Pick',
    'ui.browse': 'Browse',
    'ui.upload': 'Upload',
    'ui.download': 'Download',
    'ui.preview': 'Preview',
    'ui.fullscreen': 'Fullscreen',
    'ui.zoomIn': 'Zoom In',
    'ui.zoomOut': 'Zoom Out',
    'ui.rotate': 'Rotate',
    'ui.crop': 'Crop',
    'ui.reset': 'Reset',
    'ui.apply': 'Apply',
    'ui.accept': 'Accept',
    'ui.decline': 'Decline',
    'ui.approve': 'Approve',
    'ui.reject': 'Reject',
    'ui.cancelled': 'Cancelled',
    'ui.inProgress': 'In Progress',
    'ui.onHold': 'On Hold',
    'ui.scheduled': 'Scheduled',
    'ui.draft': 'Draft',
    'ui.published': 'Published',
    'ui.unpublished': 'Unpublished',
    'ui.archived': 'Archived',
    'ui.deleted': 'Deleted',
    'ui.restored': 'Restored',
    'ui.duplicated': 'Duplicated',
    'ui.moved': 'Moved',
    'ui.copied': 'Copied',
    'ui.shared': 'Shared',
    'ui.liked': 'Liked',
    'ui.disliked': 'Disliked',
    'ui.commented': 'Commented',
    'ui.replied': 'Replied',
    'ui.mentioned': 'Mentioned',
    'ui.tagged': 'Tagged',
    'ui.followed': 'Followed',
    'ui.unfollowed': 'Unfollowed',
    'ui.subscribed': 'Subscribed',
    'ui.unsubscribed': 'Unsubscribed',
    'ui.notifications': 'Notifications',
    'ui.settings': 'Settings',
    'ui.preferences': 'Preferences',
    'ui.account': 'Account',
    'ui.profile': 'Profile',
    'ui.logout': 'Logout',
    'ui.signOut': 'Sign Out',
    'ui.signIn': 'Sign In',
    'ui.signUp': 'Sign Up',
    'ui.register': 'Register',
    'ui.login': 'Login',
    'ui.forgotPassword': 'Forgot Password?',
    'ui.resetPassword': 'Reset Password',
    'ui.changePassword': 'Change Password',
    'ui.updatePassword': 'Update Password',
    'ui.currentPassword': 'Current Password',
    'ui.newPassword': 'New Password',
    'ui.confirmPassword': 'Confirm Password',
    'ui.passwordsDoNotMatch': 'Passwords do not match',
    'ui.passwordTooShort': 'Password must be at least 8 characters',
    'ui.invalidEmail': 'Invalid email address',
    'ui.emailAlreadyExists': 'Email already exists',
    'ui.invalidCredentials': 'Invalid credentials',
    'ui.accountCreated': 'Account created successfully',
    'ui.accountUpdated': 'Account updated successfully',
    'ui.accountDeleted': 'Account deleted successfully',
    'ui.passwordChanged': 'Password changed successfully',
    'ui.emailSent': 'Email sent successfully',
    'ui.checkYourEmail': 'Check your email',
    'ui.verifyEmail': 'Verify Email',
    'ui.emailVerified': 'Email verified',
    'ui.verificationFailed': 'Verification failed',
    'ui.resendVerification': 'Resend Verification',
    'ui.verificationSent': 'Verification sent',
    'ui.rememberMe': 'Remember Me',
    'ui.keepMeSignedIn': 'Keep me signed in',
    'ui.termsOfService': 'Terms of Service',
    'ui.privacyPolicy': 'Privacy Policy',
    'ui.cookiePolicy': 'Cookie Policy',
    'ui.agreeToTerms': 'I agree to the Terms of Service',
    'ui.agreeToPrivacy': 'I agree to the Privacy Policy',
    'ui.mustAgreeToTerms': 'You must agree to the terms',
    'ui.welcome': 'Welcome',
    'ui.welcomeBack': 'Welcome Back',
    'ui.goodMorning': 'Good Morning',
    'ui.goodAfternoon': 'Good Afternoon',
    'ui.goodEvening': 'Good Evening',
    'ui.hello': 'Hello',
    'ui.hi': 'Hi',
    'ui.hey': 'Hey',
    'ui.thanks': 'Thanks',
    'ui.thankYou': 'Thank You',
    'ui.youAreWelcome': 'You\'re Welcome',
    'ui.noProblem': 'No Problem',
    'ui.sorry': 'Sorry',
    'ui.myApologies': 'My Apologies',
    'ui.excuseMe': 'Excuse Me',
    'ui.please': 'Please',
    'ui.pleaseWait': 'Please Wait',
    'ui.oneMoment': 'One Moment',
    'ui.justASecond': 'Just a Second',
    'ui.almostDone': 'Almost Done',
    'ui.processing': 'Processing',
    'ui.uploading': 'Uploading',
    'ui.downloading': 'Downloading',
    'ui.saving': 'Saving',
    'ui.deleting': 'Deleting',
    'ui.updating': 'Updating',
    'ui.creating': 'Creating',
    'ui.editing': 'Editing',
    'ui.submitting': 'Submitting',
    'ui.sending': 'Sending',
    'ui.receiving': 'Receiving',
    'ui.syncing': 'Syncing',
    'ui.refreshing': 'Refreshing',
    'ui.loadingMore': 'Loading More',
    'ui.fetching': 'Fetching',
    'ui.searching': 'Searching',
    'ui.filtering': 'Filtering',
    'ui.sorting': 'Sorting',
    'ui.calculating': 'Calculating',
    'ui.validating': 'Validating',
    'ui.verifying': 'Verifying',
    'ui.checking': 'Checking',
    'ui.connecting': 'Connecting',
    'ui.disconnecting': 'Disconnecting',
    'ui.reconnecting': 'Reconnecting',
    'ui.connected': 'Connected',
    'ui.disconnected': 'Disconnected',
    'ui.offline': 'Offline',
    'ui.online': 'Online',
    'ui.away': 'Away',
    'ui.busy': 'Busy',
    'ui.available': 'Available',
    'ui.unavailable': 'Unavailable',
    'ui.invisible': 'Invisible',
    'ui.status': 'Status',
    'ui.updateStatus': 'Update Status',
    'ui.clearStatus': 'Clear Status',
    'ui.setStatus': 'Set Status',
    'ui.customStatus': 'Custom Status',
    'ui.typing': 'Typing',
    'ui.recording': 'Recording',
    'ui.paused': 'Paused',
    'ui.playing': 'Playing',
    'ui.stopped': 'Stopped',
    'ui.muted': 'Muted',
    'ui.unmuted': 'Unmuted',
    'ui.volume': 'Volume',
    'ui.speed': 'Speed',
    'ui.quality': 'Quality',
    'ui.resolution': 'Resolution',
    'ui.format': 'Format',
    'ui.size': 'Size',
    'ui.dimensions': 'Dimensions',
    'ui.duration': 'Duration',
    'ui.length': 'Length',
    'ui.width': 'Width',
    'ui.height': 'Height',
    'ui.depth': 'Depth',
    'ui.weight': 'Weight',
    'ui.color': 'Color',
    'ui.colors': 'Colors',
    'ui.material': 'Material',
    'ui.materials': 'Materials',
    'ui.brand': 'Brand',
    'ui.brands': 'Brands',
    'ui.model': 'Model',
    'ui.models': 'Models',
    'ui.sku': 'SKU',
    'ui.barcode': 'Barcode',
    'ui.serialNumber': 'Serial Number',
    'ui.warranty': 'Warranty',
    'ui.returnPolicy': 'Return Policy',
    'ui.shippingPolicy': 'Shipping Policy',
    'ui.deliveryTime': 'Delivery Time',
    'ui.estimatedDelivery': 'Estimated Delivery',
    'ui.trackingNumber': 'Tracking Number',
    'ui.trackOrder': 'Track Order',
    'ui.orderStatus': 'Order Status',
    'ui.orderNumber': 'Order Number',
    'ui.orderDate': 'Order Date',
    'ui.deliveryDate': 'Delivery Date',
    'ui.shipDate': 'Ship Date',
    'ui.arrivalDate': 'Arrival Date',
    'ui.pickupDate': 'Pickup Date',
    'ui.meetupLocation': 'Meetup Location',
    'ui.meetupTime': 'Meetup Time',
    'ui.scheduleMeetup': 'Schedule Meetup',
    'ui.confirmMeetup': 'Confirm Meetup',
    'ui.cancelMeetup': 'Cancel Meetup',
    'ui.rescheduleMeetup': 'Reschedule Meetup',
    'ui.meetupConfirmed': 'Meetup Confirmed',
    'ui.meetupCancelled': 'Meetup Cancelled',
    'ui.rateTransaction': 'Rate Transaction',
    'ui.rateSeller': 'Rate Seller',
    'ui.rateBuyer': 'Rate Buyer',
    'ui.leaveFeedback': 'Leave Feedback',
    'ui.writeReview': 'Write Review',
    'ui.editReview': 'Edit Review',
    'ui.deleteReview': 'Delete Review',
    'ui.reportReview': 'Report Review',
    'ui.helpful': 'Helpful',
    'ui.notHelpful': 'Not Helpful',
    'ui.report': 'Report',
    'ui.flag': 'Flag',
    'ui.block': 'Block',
    'ui.unblock': 'Unblock',
    'ui.mute': 'Mute',
    'ui.unmute': 'Unmute',
    'ui.follow': 'Follow',
    'ui.unfollow': 'Unfollow',
    'ui.message': 'Message',
    'ui.call': 'Call',
    'ui.email': 'Email',
    'ui.website': 'Website',
    'ui.socialMedia': 'Social Media'
  },
  
  fr: {
    // Navigation
    'nav.shop': 'Magasiner',
    'nav.sell': 'Vendre',
    'nav.myItems': 'Mes Articles',
    'nav.favorites': 'Favoris',
    'nav.messages': 'Messages',
    
    // Common
    'common.loading': 'Chargement...',
    'common.error': 'Erreur',
    'common.success': 'Succès',
    'common.cancel': 'Annuler',
    'common.save': 'Enregistrer',
    'common.delete': 'Supprimer',
    'common.edit': 'Modifier',
    'common.view': 'Voir',
    'common.close': 'Fermer',
    'common.search': 'Rechercher',
    'common.filter': 'Filtrer',
    'common.clear': 'Effacer',
    'common.submit': 'Soumettre',
    'common.back': 'Retour',
    'common.next': 'Suivant',
    'common.previous': 'Précédent',
    
    // Auth
    'auth.signIn': 'Se connecter',
    'auth.signUp': "S'inscrire",
    'auth.signOut': 'Se déconnecter',
    'auth.email': 'Courriel',
    'auth.password': 'Mot de passe',
    'auth.name': 'Nom',
    'auth.confirmPassword': 'Confirmer le mot de passe',
    'auth.forgotPassword': 'Mot de passe oublié?',
    'auth.rememberMe': 'Se souvenir de moi',
    'auth.signInWithGoogle': 'Se connecter avec Google',
    
    // Listing
    'listing.title': 'Titre',
    'listing.titlePlaceholder': 'ex., Ensemble de bodys pour nouveau-nés',
    'listing.price': 'Prix',
    'listing.category': 'Catégorie',
    'listing.condition': 'État',
    'listing.description': 'Description',
    'listing.location': 'Emplacement',
    'listing.photos': 'Photos',
    'listing.createListing': 'Créer une nouvelle annonce',
    'listing.creating': 'Création de l\'annonce...',
    'listing.publish': 'Publier l\'annonce',
    'listing.editListing': 'Modifier l\'annonce',
    'listing.deleteListing': 'Supprimer l\'annonce',
    'listing.markAsSold': 'Marquer comme vendu',
    'listing.itemSold': 'Article vendu',
    'listing.messageSeller': 'Contacter le vendeur',
    'listing.recordPayment': 'Enregistrer le paiement',
    'listing.updatePayment': 'Mettre à jour le paiement',
    
    // Categories
    'category.all': 'Tous',
    'category.prenatal': 'Pré-natal',
    'category.clothing': 'Vêtements',
    'category.gear': 'Équipement',
    'category.toys': 'Jouets',
    'category.feeding': 'Alimentation',
    'category.nursery': 'Chambre',
    'category.other': 'Autre',
    
    // Conditions
    'condition.excellent': 'Excellent',
    'condition.good': 'Bon',
    'condition.fair': 'Correct',
    'condition.poor': 'Mauvais',
    
    // Payment
    'payment.amount': 'Montant payé',
    'payment.method': 'Méthode de paiement',
    'payment.notes': 'Notes (optionnel)',
    'payment.cash': 'Comptant',
    'payment.interac': 'Virement Interac',
    'payment.paypal': 'PayPal',
    'payment.venmo': 'Venmo',
    'payment.zelle': 'Zelle',
    'payment.cashApp': 'Cash App',
    'payment.other': 'Autre',
    'payment.approvals': 'Approbations de paiement',
    'payment.pendingApprovals': 'Aucune approbation en attente',
    'payment.noPendingApprovalsDescription': 'Toutes les demandes de paiement ont été examinées.',
    'payment.pendingApprovals': 'Approbations de paiement en attente',
    'payment.pending': 'en attente',
    'payment.from': 'Paiement de',
    'payment.requestedAt': 'Demandé',
    'payment.approve': 'Approuver',
    'payment.reject': 'Rejeter',
    'payment.rejectionReason': 'Veuillez fournir une raison pour le rejet:',
    
    // Messages
    'messages.noMessages': 'Aucun message',
    'messages.startConversation': 'Commencer une conversation',
    'messages.typeMessage': 'Tapez un message...',
    'messages.send': 'Envoyer',
    'messages.unread': 'non lu',
    
    // Reviews
    'reviews.noReviews': 'Aucun avis',
    'reviews.writeReview': 'Écrire un avis',
    'reviews.rating': 'Note',
    'reviews.comment': 'Commentaire',
    'reviews.submitReview': 'Soumettre l\'avis',
    
    // Pages
    'page.browse': 'Parcourir les articles',
    'page.browseDescription': 'Trouvez des articles pour bébés usagés de parents de votre communauté',
    'page.myListings': 'Mes annonces',
    'page.myListingsDescription': 'Gérez vos articles pour bébés à vendre',
    'page.favorites': 'Mes favoris',
    'page.favoritesDescription': 'Articles que vous avez sauvegardés pour plus tard',
    'page.messages': 'Messages',
    'page.profile': 'Profil',
    'page.createListing': 'Créer une nouvelle annonce',
    'page.createListingDescription': 'Partagez des articles pour bébés usagés avec votre communauté',
    
    // Tagline
    'tagline': 'BabyXchange - Créé par des parents, pour des parents',
    
    // Additional UI Elements
    'ui.createNewListing': 'Créer une nouvelle annonce',
    'ui.noListingsYet': 'Aucune annonce pour le moment',
    'ui.startSelling': 'Commencez à vendre vos articles pour bébés!',
    'ui.noItemsFound': 'Aucun article trouvé',
    'ui.tryAdjustingFilters': 'Essayez d\'ajuster vos filtres',
    'ui.clearFilters': 'Effacer les filtres',
    'ui.showing': 'Affichage',
    'ui.results': 'résultats',
    'ui.sortBy': 'Trier par',
    'ui.newest': 'Plus récent',
    'ui.oldest': 'Plus ancien',
    'ui.priceLowToHigh': 'Prix: Bas à élevé',
    'ui.priceHighToLow': 'Prix: Élevé à bas',
    'ui.distance': 'Distance',
    'ui.advancedFilters': 'Filtres avancés',
    'ui.resetFilters': 'Réinitialiser les filtres',
    'ui.applyFilters': 'Appliquer les filtres',
    'ui.maxDistance': 'Distance maximale',
    'ui.km': 'km',
    'ui.minPrice': 'Prix minimum',
    'ui.maxPrice': 'Prix maximum',
    'ui.ageRange': 'Tranche d\'âge',
    'ui.customRange': 'Plage personnalisée',
    'ui.from': 'De',
    'ui.to': 'À',
    'ui.months': 'mois',
    'ui.useMyLocation': 'Utiliser ma position actuelle',
    'ui.addPhotos': 'Ajouter des photos',
    'ui.dragDropPhotos': 'Glissez-déposez des photos ici, ou cliquez pour sélectionner',
    'ui.uploadPhotos': 'Téléchargez jusqu\'à 5 photos',
    'ui.addMorePhotos': 'Ajouter plus de photos',
    'ui.removePhoto': 'Supprimer la photo',
    'ui.description': 'Description',
    'ui.descriptionPlaceholder': 'Décrivez votre article en détail...',
    'ui.tags': 'Étiquettes',
    'ui.addTags': 'Ajouter des étiquettes (ex: Déménagement, À donner)',
    'ui.pressEnter': 'Appuyez sur Entrée pour ajouter',
    'ui.quickMessages': 'Messages rapides',
    'ui.sendMessage': 'Envoyer un message',
    'ui.areYouSureDelete': 'Êtes-vous sûr de vouloir supprimer cette annonce?',
    'ui.active': 'Actif',
    'ui.sold': 'Vendu',
    'ui.inactive': 'Inactif',
    'ui.pending': 'En attente',
    'ui.approved': 'Approuvé',
    'ui.rejected': 'Rejeté',
    'ui.completed': 'Complété',
    'ui.itemSold': 'Article vendu',
    'ui.signInToMessage': 'Connectez-vous pour envoyer un message',
    'ui.onlyBuyersCanReview': 'Seuls les acheteurs peuvent laisser des avis. Achetez cet article pour évaluer le vendeur.',
    'ui.alreadyReviewed': 'Vous avez déjà évalué ce vendeur!',
    'ui.cannotReviewOwn': 'Vous ne pouvez pas évaluer votre propre annonce.',
    'ui.signInToReview': 'Veuillez vous connecter pour laisser un avis.',
    'ui.leaveReview': 'Laisser un avis',
    'ui.submitReview': 'Soumettre l\'avis',
    'ui.youMayAlsoLike': 'Vous aimerez peut-être aussi',
    'ui.similarItems': 'Articles similaires',
    'ui.otherListings': 'Autres annonces',
    'ui.fromThisSeller': 'de ce vendeur',
    'ui.qualityAssurance': 'Assurance qualité',
    'ui.startQA': 'Démarrer AQ',
    'ui.hideQA': 'Masquer AQ',
    'ui.affiliateProducts': 'Produits affiliés',
    'ui.similarProducts': 'Produits similaires',
    'ui.recommendedForYou': 'Recommandé pour vous',
    'ui.viewOnAmazon': 'Voir sur Amazon',
    'ui.aiAssistant': 'Assistant IA',
    'ui.clearChat': 'Effacer la discussion',
    'ui.typeYourQuestion': 'Tapez votre question...',
    'ui.send': 'Envoyer',
    'ui.thinking': 'Réflexion...',
    'ui.enterMessage': 'Entrez votre message...',
    'ui.chatWithAI': 'Discuter avec l\'IA',
    'ui.aiThinking': 'L\'IA réfléchit...',
    'ui.noConversations': 'Aucune conversation',
    'ui.startConversation': 'Commencer une conversation',
    'ui.noMessages': 'Aucun message',
    'ui.typeMessage': 'Tapez un message...',
    'ui.unread': 'non lu',
    'ui.markAsRead': 'Marquer comme lu',
    'ui.searchPlaceholder': 'Rechercher des articles...',
    'ui.recentSearches': 'Recherches récentes',
    'ui.clearRecent': 'Effacer les récentes',
    'ui.noRecentSearches': 'Aucune recherche récente',
    'ui.searchResults': 'Résultats de recherche',
    'ui.noSearchResults': 'Aucun résultat trouvé',
    'ui.tryDifferentKeywords': 'Essayez des mots-clés différents',
    'ui.suggestions': 'Suggestions',
    'ui.popularSearches': 'Recherches populaires',
    'ui.viewAll': 'Voir tout',
    'ui.seeMore': 'Voir plus',
    'ui.seeLess': 'Voir moins',
    'ui.loadMore': 'Charger plus',
    'ui.noMoreItems': 'Plus d\'articles',
    'ui.emptyState': 'Rien ici pour le moment',
    'ui.comingSoon': 'Bientôt disponible',
    'ui.underConstruction': 'En construction',
    'ui.notAvailable': 'Non disponible',
    'ui.soldOut': 'Épuisé',
    'ui.outOfStock': 'Rupture de stock',
    'ui.inStock': 'En stock',
    'ui.available': 'Disponible',
    'ui.unavailable': 'Indisponible',
    'ui.contactSeller': 'Contacter le vendeur',
    'ui.askQuestion': 'Poser une question',
    'ui.reportListing': 'Signaler l\'annonce',
    'ui.shareListing': 'Partager l\'annonce',
    'ui.saveForLater': 'Sauvegarder pour plus tard',
    'ui.removeFromFavorites': 'Retirer des favoris',
    'ui.addToFavorites': 'Ajouter aux favoris',
    'ui.favorited': 'Ajouté aux favoris',
    'ui.unfavorited': 'Retiré des favoris',
    'ui.viewProfile': 'Voir le profil',
    'ui.sellerInfo': 'Informations du vendeur',
    'ui.buyerInfo': 'Informations de l\'acheteur',
    'ui.location': 'Emplacement',
    'ui.distanceAway': 'de distance',
    'ui.posted': 'Publié',
    'ui.updated': 'Mis à jour',
    'ui.lastActive': 'Dernière activité',
    'ui.joined': 'Inscrit',
    'ui.memberSince': 'Membre depuis',
    'ui.verified': 'Vérifié',
    'ui.unverified': 'Non vérifié',
    'ui.trusted': 'De confiance',
    'ui.new': 'Nouveau',
    'ui.featured': 'En vedette',
    'ui.promoted': 'Promu',
    'ui.hot': 'Populaire',
    'ui.trending': 'Tendance',
    'ui.bestSeller': 'Meilleure vente',
    'ui.topRated': 'Mieux noté',
    'ui.recommended': 'Recommandé',
    'ui.similarItems': 'Articles similaires',
    'ui.recentlyViewed': 'Récemment consultés',
    'ui.trendingNow': 'Tendances actuelles',
    'ui.popularCategories': 'Catégories populaires',
    'ui.allCategories': 'Toutes les catégories',
    'ui.filterBy': 'Filtrer par',
    'ui.all': 'Tous',
    'ui.any': 'N\'importe',
    'ui.none': 'Aucun',
    'ui.select': 'Sélectionner',
    'ui.selectAll': 'Tout sélectionner',
    'ui.deselectAll': 'Tout désélectionner',
    'ui.choose': 'Choisir',
    'ui.pick': 'Choisir',
    'ui.browse': 'Parcourir',
    'ui.upload': 'Télécharger',
    'ui.download': 'Télécharger',
    'ui.preview': 'Aperçu',
    'ui.fullscreen': 'Plein écran',
    'ui.zoomIn': 'Zoom avant',
    'ui.zoomOut': 'Zoom arrière',
    'ui.rotate': 'Pivoter',
    'ui.crop': 'Recadrer',
    'ui.reset': 'Réinitialiser',
    'ui.apply': 'Appliquer',
    'ui.accept': 'Accepter',
    'ui.decline': 'Refuser',
    'ui.approve': 'Approuver',
    'ui.reject': 'Rejeter',
    'ui.cancelled': 'Annulé',
    'ui.inProgress': 'En cours',
    'ui.onHold': 'En attente',
    'ui.scheduled': 'Planifié',
    'ui.draft': 'Brouillon',
    'ui.published': 'Publié',
    'ui.unpublished': 'Non publié',
    'ui.archived': 'Archivé',
    'ui.deleted': 'Supprimé',
    'ui.restored': 'Restauré',
    'ui.duplicated': 'Dupliqué',
    'ui.moved': 'Déplacé',
    'ui.copied': 'Copié',
    'ui.shared': 'Partagé',
    'ui.liked': 'Aimé',
    'ui.disliked': 'Pas aimé',
    'ui.commented': 'Commenté',
    'ui.replied': 'Répondu',
    'ui.mentioned': 'Mentionné',
    'ui.tagged': 'Étiqueté',
    'ui.followed': 'Suivi',
    'ui.unfollowed': 'Non suivi',
    'ui.subscribed': 'Abonné',
    'ui.unsubscribed': 'Désabonné',
    'ui.notifications': 'Notifications',
    'ui.settings': 'Paramètres',
    'ui.preferences': 'Préférences',
    'ui.account': 'Compte',
    'ui.profile': 'Profil',
    'ui.logout': 'Déconnexion',
    'ui.signOut': 'Se déconnecter',
    'ui.signIn': 'Se connecter',
    'ui.signUp': 'S\'inscrire',
    'ui.register': 'S\'inscrire',
    'ui.login': 'Connexion',
    'ui.forgotPassword': 'Mot de passe oublié?',
    'ui.resetPassword': 'Réinitialiser le mot de passe',
    'ui.changePassword': 'Changer le mot de passe',
    'ui.updatePassword': 'Mettre à jour le mot de passe',
    'ui.currentPassword': 'Mot de passe actuel',
    'ui.newPassword': 'Nouveau mot de passe',
    'ui.confirmPassword': 'Confirmer le mot de passe',
    'ui.passwordsDoNotMatch': 'Les mots de passe ne correspondent pas',
    'ui.passwordTooShort': 'Le mot de passe doit contenir au moins 8 caractères',
    'ui.invalidEmail': 'Adresse courriel invalide',
    'ui.emailAlreadyExists': 'Le courriel existe déjà',
    'ui.invalidCredentials': 'Identifiants invalides',
    'ui.accountCreated': 'Compte créé avec succès',
    'ui.accountUpdated': 'Compte mis à jour avec succès',
    'ui.accountDeleted': 'Compte supprimé avec succès',
    'ui.passwordChanged': 'Mot de passe changé avec succès',
    'ui.emailSent': 'Courriel envoyé avec succès',
    'ui.checkYourEmail': 'Vérifiez votre courriel',
    'ui.verifyEmail': 'Vérifier le courriel',
    'ui.emailVerified': 'Courriel vérifié',
    'ui.verificationFailed': 'Vérification échouée',
    'ui.resendVerification': 'Renvoyer la vérification',
    'ui.verificationSent': 'Vérification envoyée',
    'ui.rememberMe': 'Se souvenir de moi',
    'ui.keepMeSignedIn': 'Rester connecté',
    'ui.termsOfService': 'Conditions d\'utilisation',
    'ui.privacyPolicy': 'Politique de confidentialité',
    'ui.cookiePolicy': 'Politique des cookies',
    'ui.agreeToTerms': 'J\'accepte les conditions d\'utilisation',
    'ui.agreeToPrivacy': 'J\'accepte la politique de confidentialité',
    'ui.mustAgreeToTerms': 'Vous devez accepter les conditions',
    'ui.welcome': 'Bienvenue',
    'ui.welcomeBack': 'Bon retour',
    'ui.goodMorning': 'Bonjour',
    'ui.goodAfternoon': 'Bon après-midi',
    'ui.goodEvening': 'Bonsoir',
    'ui.hello': 'Bonjour',
    'ui.hi': 'Salut',
    'ui.hey': 'Hé',
    'ui.thanks': 'Merci',
    'ui.thankYou': 'Merci',
    'ui.youAreWelcome': 'De rien',
    'ui.noProblem': 'Pas de problème',
    'ui.sorry': 'Désolé',
    'ui.myApologies': 'Mes excuses',
    'ui.excuseMe': 'Excusez-moi',
    'ui.please': 'S\'il vous plaît',
    'ui.pleaseWait': 'Veuillez patienter',
    'ui.oneMoment': 'Un instant',
    'ui.justASecond': 'Une seconde',
    'ui.almostDone': 'Presque terminé',
    'ui.processing': 'Traitement',
    'ui.uploading': 'Téléchargement',
    'ui.downloading': 'Téléchargement',
    'ui.saving': 'Enregistrement',
    'ui.deleting': 'Suppression',
    'ui.updating': 'Mise à jour',
    'ui.creating': 'Création',
    'ui.editing': 'Modification',
    'ui.submitting': 'Soumission',
    'ui.sending': 'Envoi',
    'ui.receiving': 'Réception',
    'ui.syncing': 'Synchronisation',
    'ui.refreshing': 'Actualisation',
    'ui.loadingMore': 'Chargement de plus',
    'ui.fetching': 'Récupération',
    'ui.searching': 'Recherche',
    'ui.filtering': 'Filtrage',
    'ui.sorting': 'Tri',
    'ui.calculating': 'Calcul',
    'ui.validating': 'Validation',
    'ui.verifying': 'Vérification',
    'ui.checking': 'Vérification',
    'ui.connecting': 'Connexion',
    'ui.disconnecting': 'Déconnexion',
    'ui.reconnecting': 'Reconnexion',
    'ui.connected': 'Connecté',
    'ui.disconnected': 'Déconnecté',
    'ui.offline': 'Hors ligne',
    'ui.online': 'En ligne',
    'ui.away': 'Absent',
    'ui.busy': 'Occupé',
    'ui.available': 'Disponible',
    'ui.unavailable': 'Indisponible',
    'ui.invisible': 'Invisible',
    'ui.status': 'Statut',
    'ui.updateStatus': 'Mettre à jour le statut',
    'ui.clearStatus': 'Effacer le statut',
    'ui.setStatus': 'Définir le statut',
    'ui.customStatus': 'Statut personnalisé',
    'ui.typing': 'Saisie',
    'ui.recording': 'Enregistrement',
    'ui.paused': 'En pause',
    'ui.playing': 'Lecture',
    'ui.stopped': 'Arrêté',
    'ui.muted': 'Muet',
    'ui.unmuted': 'Son activé',
    'ui.volume': 'Volume',
    'ui.speed': 'Vitesse',
    'ui.quality': 'Qualité',
    'ui.resolution': 'Résolution',
    'ui.format': 'Format',
    'ui.size': 'Taille',
    'ui.dimensions': 'Dimensions',
    'ui.duration': 'Durée',
    'ui.length': 'Longueur',
    'ui.width': 'Largeur',
    'ui.height': 'Hauteur',
    'ui.depth': 'Profondeur',
    'ui.weight': 'Poids',
    'ui.color': 'Couleur',
    'ui.colors': 'Couleurs',
    'ui.material': 'Matériau',
    'ui.materials': 'Matériaux',
    'ui.brand': 'Marque',
    'ui.brands': 'Marques',
    'ui.model': 'Modèle',
    'ui.models': 'Modèles',
    'ui.sku': 'UGS',
    'ui.barcode': 'Code-barres',
    'ui.serialNumber': 'Numéro de série',
    'ui.warranty': 'Garantie',
    'ui.returnPolicy': 'Politique de retour',
    'ui.shippingPolicy': 'Politique d\'expédition',
    'ui.deliveryTime': 'Délai de livraison',
    'ui.estimatedDelivery': 'Livraison estimée',
    'ui.trackingNumber': 'Numéro de suivi',
    'ui.trackOrder': 'Suivre la commande',
    'ui.orderStatus': 'Statut de la commande',
    'ui.orderNumber': 'Numéro de commande',
    'ui.orderDate': 'Date de commande',
    'ui.deliveryDate': 'Date de livraison',
    'ui.shipDate': 'Date d\'expédition',
    'ui.arrivalDate': 'Date d\'arrivée',
    'ui.pickupDate': 'Date de ramassage',
    'ui.meetupLocation': 'Lieu de rencontre',
    'ui.meetupTime': 'Heure de rencontre',
    'ui.scheduleMeetup': 'Planifier une rencontre',
    'ui.confirmMeetup': 'Confirmer la rencontre',
    'ui.cancelMeetup': 'Annuler la rencontre',
    'ui.rescheduleMeetup': 'Reprogrammer la rencontre',
    'ui.meetupConfirmed': 'Rencontre confirmée',
    'ui.meetupCancelled': 'Rencontre annulée',
    'ui.rateTransaction': 'Évaluer la transaction',
    'ui.rateSeller': 'Évaluer le vendeur',
    'ui.rateBuyer': 'Évaluer l\'acheteur',
    'ui.leaveFeedback': 'Laisser un commentaire',
    'ui.writeReview': 'Écrire un avis',
    'ui.editReview': 'Modifier l\'avis',
    'ui.deleteReview': 'Supprimer l\'avis',
    'ui.reportReview': 'Signaler l\'avis',
    'ui.helpful': 'Utile',
    'ui.notHelpful': 'Pas utile',
    'ui.report': 'Signaler',
    'ui.flag': 'Signaler',
    'ui.block': 'Bloquer',
    'ui.unblock': 'Débloquer',
    'ui.mute': 'Mettre en sourdine',
    'ui.unmute': 'Activer le son',
    'ui.follow': 'Suivre',
    'ui.unfollow': 'Ne plus suivre',
    'ui.message': 'Message',
    'ui.call': 'Appeler',
    'ui.email': 'Courriel',
    'ui.website': 'Site web',
    'ui.socialMedia': 'Médias sociaux'
  }
};

export function useTranslation() {
  const { language } = useLanguage();
  
  const t = (key, fallback = key) => {
    return translations[language]?.[key] || fallback;
  };
  
  return { t, language };
}
